<template>
  <div></div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  watch: {
    favourites (newFavs, oldFavs) {
      if (JSON.stringify(newFavs) !== JSON.stringify(oldFavs)) {
        if (newFavs.length === 0) {
          this.$router.push(`/category/${this.$route.params.categoryId}/live`)
        } else {
          this.$router.push(this.viewFavouritesLink)
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      favourites: 'favourites/favourites',
      viewFavouritesLink: 'favourites/viewFavouritesLink'
    })
  },

  mounted () {
    this.$store.commit('favourites/SET_FAVOURITES_BACK_LINK', this.$store.state.route.from.fullPath)
    
    const propertyIds = this.$store.state.route.query.p ? this.$store.state.route.query.p.split(',') : []
    if (propertyIds.length) {
      this.$store.commit('favourites/SET_FAVOURITES', propertyIds)
    }
  },
}
</script>
